import classNames from 'classnames';
import { differenceInYears, format } from 'date-fns';
import { isUndefined } from 'lodash-es';
import * as React from 'react';
import EReview from '../../../domain/entities/Review';
import StringUtils from '../../utils/StringUtils';
import StarRating from '../icons/StarRating';
import css from './Review.module.scss';

interface Props {
  className?: string;
  review: EReview;
}

const Review = ({ className, review }: Props) => {
  const classes = classNames(css.Review, className);
  // TODO: move to utils
  const age = review.birthday
    ? differenceInYears(new Date(), new Date(review.birthday))
    : 0;
  const displayAge = age < 20 ? '10代以下' : `${Math.floor(age / 10) * 10}代`;
  const replyDate =
    review.reply && review.reply.updatedAt
      ? new Date(review.reply.updatedAt)
      : new Date();

  return (
    <li className={classes}>
      <div className={css.Review__Header}>
        <p className={css.Review__Customer}>
          <span className={css.Review__CustomerName}>
            {/* TODO: move to utils or resolve on API */}
            {review.name === 'Anonymous' ? 'クービックユーザー' : review.name}
          </span>
          {review.gender && (
            <span className={css.Review__CustomerGender}>
              {/* TODO: move to utils or resolve on API */}
              {` ${review.gender === 'female' ? '女性' : '男性'}`}
            </span>
          )}
          {review.birthday && (
            <span
              className={css.Review__CustomerAge}
            >{` | ${displayAge}`}</span>
          )}
        </p>
        {!isUndefined(review.rating) && (
          <StarRating className={css.Review__StarRating} rate={review.rating} />
        )}
      </div>
      {review.comment && (
        <div className={css.Review__Body}>
          {StringUtils.simpleFormat(review.comment)}
        </div>
      )}
      <div className={css.Review__Footer}>
        <p className={css.Review__Date}>
          {/* TODO: move to utils */}
          {format(new Date(review.updatedAt), 'YYYY年MM月DD日')}
        </p>
      </div>
      {review.reply && (
        <div className={css.Review__Reply}>
          <b className={css.Review__ReplyLabel}>返信コメント</b>
          {StringUtils.simpleFormat(review.reply.comment)}
          <span className={css.Review__ReplyDate}>
            {format(replyDate, 'YYYY年MM月DD日')}
          </span>
        </div>
      )}
    </li>
  );
};

export default Review;
